import { combineReducers } from 'redux';
import {
  setCurrentOrganizationTab, setCurrentOwnOrganizationTab, setCurrentProfileTab,
  setCurrentProjectTab, setCurrentUserTab, setCurrentVideoMenuTab,
} from '../actions';
import { ActionTypes } from '../types';


const organizationTab = (state = '/dashboard/admin/organizations/:id/account', action: ActionTypes) => {
  switch (action.type) {
    case setCurrentOrganizationTab.type:
      return action.payload;

    default:
      return state;
  }
};

const projectTab = (state = '/dashboard/projects/:id/overview', action: ActionTypes) => {
  switch (action.type) {
    case setCurrentProjectTab.type:
      return action.payload;

    default:
      return state;
  }
};

const profileTab = (state = '/dashboard/profile/me', action: ActionTypes) => {
  switch (action.type) {
    case setCurrentProfileTab.type:
      return action.payload;

    default:
      return state;
  }
};

const ownOrganizationTab = (state = '/dashboard/user/organizations/:id/account', action: ActionTypes) => {
  switch (action.type) {
    case setCurrentOwnOrganizationTab.type:
      return action.payload;

    default:
      return state;
  }
};

const videoMenuTab = (state = '/dashboard/admin/video-menus/:id/info', action: ActionTypes) => {
  switch (action.type) {
    case setCurrentVideoMenuTab.type:
      return action.payload;

    default:
      return state;
  }
};

const userTab = (state = '/dashboard/admin/users/:id/profile', action: ActionTypes) => {
  switch (action.type) {
    case setCurrentUserTab.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  organizationTab,
  ownOrganizationTab,
  projectTab,
  profileTab,
  videoMenuTab,
  userTab,
});
